// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__yY2ZG","emailUser":"UserMenu_emailUser__5LlYq"};